module.exports = __webpack_public_path__ + "assets/sounds/arpeggio.mp3";